import api from '../..'

const addProfileBulkAction = (userIds: number[], profileIds: number[]) => {
  return api.post(`administration/multiple_profiles`, { multiples: { userIds, profileIds } })
}

export default addProfileBulkAction
